module.exports = __webpack_public_path__ + "c5d7aea0ce3951e5d8a7ccd592840c8d.jpg";